import { jsx } from "react/jsx-runtime";
import { PageBlock, Box, Inline } from "braid-design-system";
import { CustomDesktopSubItemHeaderLink } from "./HeaderLink.mjs";
import { root, isActive } from "./DesktopSubNavigation.css.mjs";
const DesktopSubNavigation = ({
  activeSubTabId,
  subItems,
  linkRenderer
}) => {
  if (subItems.length === 0 || subItems && !activeSubTabId) {
    return null;
  }
  return /* @__PURE__ */ jsx("section", { className: root, children: /* @__PURE__ */ jsx(PageBlock, { component: "nav", width: "full", children: /* @__PURE__ */ jsx(Box, { overflow: "hidden", paddingY: "xsmall", children: /* @__PURE__ */ jsx(Inline, { space: "medium", children: subItems.map(
    ({ id, label, href, rel, isBeta, ...headerNavItemProps }, index) => /* @__PURE__ */ jsx(
      CustomDesktopSubItemHeaderLink,
      {
        active: id === activeSubTabId,
        activeStyle: isActive,
        linkRenderer,
        isBeta,
        href,
        rel,
        "data-analytics": headerNavItemProps["data-analytics"],
        "data-test": headerNavItemProps["data-test"],
        analyticsEvent: headerNavItemProps.analyticsEvent,
        children: label
      },
      `desktop-nav-subitem-${index}`
    )
  ) }) }) }) });
};
export {
  DesktopSubNavigation
};
